import React, { Component, useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

export class PdfViewer extends Component {

    constructor(props) {
        super(props);

        const timestamp = Date.now();
        const terminosUrl = "./media/docs/terminos_condiciones.pdf?" + timestamp.toString();

        this.state = {
            pdfUrl: terminosUrl,
            numPages: window.env.PAGINAS_TERMINOS_CONDICIONES,
            pageNumber: 0,
            setNumPages: () => { }
        };

    }

    onDocumentLoadSuccess(c) {        
        c.state.setNumPages(c.state.numPages);
    }

    render() {
        return (
            <Document
                file={this.state.pdfUrl}
                onLoadSuccess={this.onDocumentLoadSuccess(this)}
            >
                {Array.from(
                    new Array(this.state.numPages),
                    (el, index) => (
                        <Page
                            key={`page_${index + 1}`}
                            pageNumber={index + 1}
                        />
                    ),
                )}
            </Document>
        );
    }
}